export const POST_ORDER_DETAILS_TO_NATIVE = 'POST_ORDER_DETAILS_TO_NATIVE';
export const POST_CANCEL_ORDER_DETAILS_OCP_TO_NATIVE = 'POST_CANCEL_ORDER_DETAILS_OCP_TO_NATIVE';
